import { useMutation, gql } from '@apollo/client';
import toast from 'helpers/toast';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  errorMsg: {
    id: 'Documents.addFromCompanyDocuments.errorMessage',
    defaultMessage:
      'There was a problem adding the document. Please try again.',
    description: 'Error message when adding documents from project documents',
  },
});

export const CREATE_FROM_COMPANY_DOCUMENT = gql`
  mutation CreateDocumentFromBlueprint(
    $input: CreateDocumentFromBlueprintInput!
  ) {
    createDocumentFromBlueprint(input: $input) {
      errors {
        error
        message
      }
    }
  }
`;
const useAddFromCompanyDocuments = ({ projectId, onSuccess = () => {} }) => {
  const { formatMessage } = useIntl();
  const [_addFromCompanyDocuments, { loading }] = useMutation(
    CREATE_FROM_COMPANY_DOCUMENT,
    {
      onCompleted: (res) => {
        const errors = res?.createDocumentFromBlueprint?.errors;

        if (errors?.length) {
          toast.error(errors[0].message);
          return;
        }
        onSuccess();
      },
      onError: () => {
        toast.error(formatMessage(messages.errorMsg));
      },
    },
  );

  const addFromCompanyDocuments = async ({ documentBlueprintIds }) => {
    return _addFromCompanyDocuments({
      variables: {
        input: {
          documentBlueprintIds,
          projectId,
        },
      },
    });
  };

  return {
    addFromCompanyDocuments,
    loading,
  };
};

export default useAddFromCompanyDocuments;
